<div class="bg-th-blue mt-0 container-fluid py-2">
    <div class=" d-flex justify-content-between align-content-center">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
        <a class="text-white f18 my-auto dirI d-flex align-items-center">لیست درآمد ها <i
                class="fa fa-question-circle my-auto me-2 fa-2x pointer" (click)="guid(30)"></i> </a>
    </div>
</div>
<div class="d-flex justify-content-start gap-2 flex-wrap dirI my-2">
    <div class="d-flex gap-1 col-md-2 col-11">
        <label class="text-center m-2">از</label>
        <form [formGroup]="dataAz">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>

    <div class="d-flex gap-1 col-md-2 col-11">
        <label class="text-center m-2">تا</label>
        <form [formGroup]="datatTa">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>

    <div class="d-flex col-md-7 col-11" [formGroup]="serchModel">
        <div class="col-md-6 d-flex col-11">
            <input type="text" placeholder="توضیحات" class="form-control text-start bg-light dirI"
                formControlName="strComment">
            <button class="btn btn-primary" (click)="serch()"><i class="fa fa-search"></i></button>
        </div>
    </div>
</div>

<div class="d-flex bg-th-blue justify-content-between gap-2 ps-3">
    <div class="ms-2">
        <button class="btn btn-success pointer ms-2"
            (click)="otherService.exportexcel('excel-table-incomeReport', 'گزارش درآمدها.xlsx') "> خروجی اکسل
            <i class="fa fa-file-excel-o"></i></button>
        <button printTitle="گزارش درآمدها" printSectionId="print-table-incomeReport" class="btn btn-secondary pointer"
            [useExistingCss]="true" ngxPrint>چاپ <i class="fa fa-print"></i></button>
    </div>
    <p class="f18 text-white text-center dirI px-3 my-auto">مجموع درآمد:
        <strong>{{otherService.getSeparatedValue(totalIncomde)}}</strong> تومان
    </p>
</div>
<div class="table-responsive dirI rounded-3  my-2" id="print-table-incomeReport"
    style="max-height: 85vh; overflow-y: auto;">
    <div class="dirI" id="print-only-flex">
        <div class="text-center align-items-center border">
            <p class="p-2">تاریخ تهیه</p>
            {{otherService.getCurrentDate() | faNum}}
        </div>
    </div>
    <table class="table table-striped mt-1 dirI" id="excel-table-incomeReport">
        <thead>
            <tr class="position-sticky bg-white top-0 text-center fw-bold">
                <th scope="col">#</th>
                <th scope="col">تاریخ</th>
                <th scope="col">مبلغ (تومان)</th>
                <th scope="col">توضیحات</th>
            </tr>
        </thead>
        <tbody>
            <tr class="text-center hoverMenu pointer f14" *ngFor="let item of Income;let i=index"
                (click)="getSingel(i)">
                <th class="text-dark">{{i+1 | faNum}}</th>
                <th class="text-dark">{{item.strDate | faNum}}</th>
                <th class="text-dark">{{otherService.getSeparatedValue(item.iAmount) | faNum}}</th>
                <th class="text-dark">{{item.strComment | faNum}}</th>
            </tr>
        </tbody>
    </table>
</div>

<!-- <div class="d-flex flex-wrap">
    <div class="d-flex flex-column col-lg-5 mx-auto card mt-3 bg-light index- col-11" *ngFor="let item of Income; index as i" (click)="getSingel(i)">

        <p class="rtl d-flex justify-content-between mx-3 mt-2"><span><i class="fa fa-calendar text-secondary"></i> تاریخ :</span><span>{{item.strDate}}</span></p>
        <p class="rtl d-flex justify-content-between mx-3"><span><i class="fa fa-money text-secondary"></i> مبلغ :</span><span>{{item.iAmount| number:'1.0':'en-US'}}</span></p>
        <p class="rtl d-flex justify-content-between mx-3"><span><i class="fa fa-list text-secondary"></i> توضیحات :</span><span>{{item.strComment}}</span></p>

    </div>
</div> -->

<!-- Button trigger modal -->
<button type="button" class="btn btn-primary btn-plus" data-bs-toggle="modal" data-bs-target="#exampleModal"
    (click)="open()">
    <i class="fa fa-plus fa-2x"></i>
</button>

<!-- Modal -->
<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content ">
            <div class="modal-header d-flex align-items-center">
                <h5 class="modal-title text-th-blue d-flex align-items-center" id="exampleModalLabel">
                    <span class="">ثبت درآمد</span>
                    <i class="fa fa-question-circle my-auto me-1 fa-2x pointer" (click)="guid(5)"></i>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <form [formGroup]="sabtModel" class="d-flex flex-wrap">
                    <div class="col-md-5 col-11 mx-auto">
                        <label class="mb-2"> تاریخ *</label>
                        <form [formGroup]="datasabt">
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                                <input type="text" formControlName="date" class="form-control shadow text-end mt-1"
                                    readonly />
                            </ng-persian-datepicker>
                        </form>
                    </div>
                    <div class="col-md-5 col-11 mx-auto mt-2">
                        <label class="mb-2">هزینه به تومان *</label>
                        <input type="text" class="form-control shadow lirI  text-end" formControlName="iAmount"
                            (keypress)="seprator($event)" />
                    </div>
                    <div class=" col-11 mx-auto mt-2">
                        <label class="mb-2">توضیحات</label>
                        <input type="text" class="form-control shadow" formControlName="strComment"
                            placeholder="توضیحات" />
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="sabt()" *ngIf="!EditeMod">ذخیره<i
                        class="fa fa-angle-double-down"></i> </button>
                <button type="button" class="btn btn-success" (click)="edit()" *ngIf="EditeMod">ویرایش</button>
                <button type="button" class="btn btn-danger" (click)="deleteIncom()" *ngIf="EditeMod">حذف <i
                        class="fa fa-trash"></i></button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="close()">بستن<i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>